import React from 'react';

type Props = {
    url: string
}

function AppGalleryMarkup({url}: Props) {
    return (<>
{`<a href="${url}">
    <img alt='Explore it on AppGallery'
         src='https://ngage-storage.ams3.digitaloceanspaces.com/assets/app-badges/huawei-appgallery-badge.png'
         height=96
    />
</a>`}
    </>);
}

export default AppGalleryMarkup;